module.exports = __webpack_public_path__ + "img/4_26.4ec4b78c.png";